module.exports = __webpack_public_path__ + "media/images/khqr_footer_logo-8b34c5d19af501509b6fb08c48999c49.png";